<div mat-dialog-title class="modal-title">
  <mat-icon>manage_accounts</mat-icon>
  <span>Editar datos personales de: {{ fullname }}</span>
  <mat-icon class="close-button" (click)="confirmCloseModal()"> cancel </mat-icon>
</div>
<mat-dialog-content>
  <form [formGroup]="studentForm" autocomplete="off">
    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field color="primary" appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput placeholder="Email" formControlName="email" name="email" autocomplete="off" />
          <mat-error>Email requerido</mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field color="primary" appearance="outline">
          <mat-label>Nombre</mat-label>
          <input matInput placeholder="Nombre" formControlName="name" name="name" autocomplete="off" />
          <mat-error>Nombre requerido</mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field color="primary" appearance="outline">
          <mat-label>Apellidos</mat-label>
          <input matInput placeholder="Apellidos" formControlName="lastname" name="lastname" autocomplete="off" />
          <mat-error>Apellidos requeridos</mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field color="primary" appearance="outline">
          <mat-label>País</mat-label>
          <input
            matInput
            placeholder="Selecciona uno"
            formControlName="countryId"
            name="countryId"
            autocomplete="off"
            [matAutocomplete]="country"
            (keyup)="filterCountry($event)"
          />
          @if (studentForm.value.countryId && getFlagFromCountryId(studentForm.value.countryId)) {
            <img matPrefix [src]="getFlagFromCountryId(studentForm.value.countryId)" class="flag" />
          }
          <mat-autocomplete #country="matAutocomplete" requireSelection [displayWith]="displayFn">
            @for (country of filteredCountries; track country) {
              <mat-option [value]="country.countryId">
                <div class="country-option">
                  @if (country.flag) {
                    <div class="flag">
                      <img [src]="country.flag" />
                    </div>
                  }
                  <span>{{ country.name }}</span>
                </div>
              </mat-option>
            }
          </mat-autocomplete>
          <mat-error>Debes seleccionar un país</mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field color="primary" appearance="outline">
          <mat-label>Ciudad</mat-label>
          <input matInput placeholder="Ciudad" formControlName="city" name="city" autocomplete="off" />
          <mat-error>Ciudad requerida</mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field color="primary" appearance="outline">
          <mat-label>DNI / Documento de identificación</mat-label>
          <input matInput placeholder="DNI / Documento de identificación" formControlName="dni" name="dni" autocomplete="off" />
          <mat-error>Documento de identificación requerido</mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field color="primary" appearance="outline">
          <mat-label>Dirección de residencia</mat-label>
          <input matInput placeholder="Dirección de residencia" formControlName="address" name="address" autocomplete="off" />
          <mat-error>Dirección de residencia requerida</mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-control">
          <mat-form-field color="primary" appearance="outline">
            <mat-label>Prefijo del país</mat-label>
            <input matInput placeholder="Prefijo del país" formControlName="phonePrefix" name="phonePrefix" autocomplete="off" />
            <mat-error>Prefijo requerido (Máx 10 caracteres)</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field color="primary" appearance="outline">
          <mat-label>Teléfono</mat-label>
          <input matInput type="tel" placeholder="Teléfono" formControlName="phone" name="phone" autocomplete="off" readonly id="phone-field" />
          <mat-error>Teléfono requerido</mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field color="primary" appearance="outline">
          <mat-label>Género</mat-label>
          <mat-select formControlName="gender" placeholder="Selecciona uno">
            <mat-option value="F">Femenino</mat-option>
            <mat-option value="M">Masculino</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field color="primary" appearance="outline">
          <mat-label>Fecha de nacimiento</mat-label>
          <input
            matInput
            type="date"
            lang="es-ES"
            formControlName="birthdate"
            name="birthdate"
            placeholder="Fecha de nacimiento"
            [min]="minBirthdate"
            [max]="maxBirthdate"
            autocomplete="off"
          />
          @if (studentForm.controls.birthdate.hasError('invalidAge')) {
            <mat-error>Debe ser mayor de 14 años</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field color="primary" appearance="outline">
          <mat-label>Escribe la nueva contraseña</mat-label>
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            name="password"
            placeholder="Escribe la nueva contraseña"
            autocomplete="off"
          />
          <button mat-icon-button type="button" matSuffix (click)="hidePassword = !hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error>Mínimo 6 caracteres</mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6 generate-password">
        <button mat-flat-button type="button" color="accent" (click)="generateRandomPassword()">Generar contraseña aleatoria</button>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button color="primary" (click)="confirmCloseModal()"> Cerrar </button>
  <button mat-flat-button color="primary" (click)="saveStudentData()" [disabled]="studentForm.invalid || isSaving">
    @if (!isSaving) {
      <span>Guardar</span>
    } @else {
      <mat-spinner class="white-spinner"></mat-spinner>
    }
  </button>
</mat-dialog-actions>
